
// export const getProductById = ({state, id})=>{
    
// }

export const getproductexpired = (state)=>{
    let add = 0;
    // products.forEach(element => {
    //     if(element.was_deleted){
    //         add = add+1;
    //     }
    // });
    state.count = add;
    return state.products;
}

export const getProductById = (state,) => {
    return state.products.find(p => p.id === 1);
  }